import React from 'react';
import { valueProps } from '../../data/mockData';

const ValueProps = () => {
  return (
    <section className="py-24 md:py-32 bg-[#f8f7f4]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Section header */}
        <div className="mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-black max-w-2xl">
            Brand-led. <span className="text-gray-400">Strategically built.</span>
          </h2>
        </div>

        {/* Value props grid */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16">
          {valueProps.map((prop) => (
            <div key={prop.id} className="group">
              <div className="flex items-start gap-6">
                <span className="text-gray-300 text-sm font-medium">{prop.number}/</span>
                <div>
                  <h3 className="text-xl md:text-2xl font-medium text-black mb-4">
                    {prop.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {prop.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
